import { AnchorLink } from 'components/anchorLink';
import classNames from 'classnames';
import styles from './SportNewsCard.module.scss';
import { Card } from 'components/cards/components/card';

export type SportNewsCardProp = {
  link: string;
  lazy?: boolean;
  title: string;
  preview?: string;
  category: string;
  description: string;
  containerClass?: string;
};
export const SportNewsCard = ({ title, link, category, preview, description, containerClass }: SportNewsCardProp) => {
  return (
    <Card containerClass={containerClass}>
      <div className={styles.imageContainer}>
        <div
          className={classNames(styles.image, styles['image-border'])}
          dangerouslySetInnerHTML={{ __html: preview ?? '' }}
          suppressHydrationWarning
        />
        <strong className={styles.category} suppressHydrationWarning>
          {category}
        </strong>
      </div>
      <AnchorLink href={link} className={styles.linkWrapper}>
        <h4 className={styles.title}>{title}</h4>
        <p className={styles.textContent}>{description}</p>
      </AnchorLink>
    </Card>
  );
};
